import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'nominas/historico-liquidaciones';

/**
 * GET Historicos Liquidaciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getHistoricosLiquidaciones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Historico Liquidacion
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getHistoricoLiquidacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Historico Liquidacion
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postHistoricoLiquidacion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Historico Liquidacion
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchHistoricoLiquidacion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * DELETE Historico Liquidacion
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteHistoricoLiquidacion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};
